const devConfig = {
    mode: 'dev',
    apiUrl: 'http://localhost:52610',
    yandexCloudBucketName: 'foxinbox',
    vkAppId: 6925192,
    vkAppScopes: 'offline,email',
    vkVersion: 5.85,
    googleAppId: '434146614201-9fnsn4ucuekeciiitbornn046d8jjuld.apps.googleusercontent.com',
    googleAppScopes: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
    facebookAppId: 447424085992802,
    facebookAppScopes: 'public_profile,email'
};

const prodConfig = {
    mode: 'prod',
    apiUrl: '',
    yandexCloudBucketName: 'foxinbox',
    vkAppId: 6925192,
    vkAppScopes: 'offline,email',
    vkVersion: 5.85,
    googleAppId: '434146614201-9fnsn4ucuekeciiitbornn046d8jjuld.apps.googleusercontent.com',
    googleAppScopes: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
    facebookAppId: 447424085992802,
    facebookAppScopes: 'public_profile,email'
};

const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;

module.exports = config;


// WEBPACK FOOTER //
// ./Content/src/config.js